/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { getCaseSendMessageLink } from "@/src/services/productService";
import { getAppointmentDisplayType } from "@/src/services/serviceWorldService";
import { AbstractCase } from "@/src/types/Entities/AbstractCase";

export default function getNavigationLinks(product: AbstractCase, caseIsDeletable?: boolean) {
  let navigationLinks: Array<{ target: string; label: string }> = [];

  if (product.isCustomerDataCompleted) {
    navigationLinks = [
      {
        target: "#documents",
        label: "Dokumente einsehen",
      },
      {
        target: getCaseSendMessageLink(product),
        label: "Nachricht senden / Dokumente hochladen",
      },
    ];
  }

  if (getAppointmentDisplayType(product) === "appointments") {
    navigationLinks.unshift({
      target: "#appointments",
      label: "Mein Beratungstermin",
    });
  }

  if (caseIsDeletable) {
    navigationLinks.push({
      target: "#deleteCase",
      label: "Fall löschen",
    });
  }

  return navigationLinks;
}
